<template>
  <div class="pub-page">
    <div class="pub-header d-flex align-items-center justify-content-between">
      <div>
        <text class="title me-1">{{$route.meta.title}} {{stage===1?"初赛":"复赛"}}</text>
      </div>
      <div class="d-flex align-items-center justify-content-center">
        <el-button type="primary" v-loading="exportLoading"  class="ms-2 me-1" @click="handleExport">导出</el-button>
<!--        <el-button type="primary"  class="ms-2 me-3" @click="handleimport">导入</el-button>-->
        <el-upload
            ref="upload"
            :headers="uploadData"
            :action="VUE_APP_uploadurl"
            class="upload-demo"
            :limit="1"
            :show-file-list="false"
            :on-exceed="handleUploadExceed"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            method="post"
            v-model:file-list="fileList"
            accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        >
          <template #trigger>
            <el-button v-loading="importLoading" type="primary" class="ms-2 me-3">导入</el-button>
          </template>
        </el-upload>
      </div>
    </div>
    <div class="pub-center pt-2" >
      <div class="search--box">
        <el-form-item label="年份：" class="me-3" >
          <!--          <el-input v-model="params.year" style="width: 100px"/>-->
          <el-select v-model="params.year" style="width: 100px" clearable>
            <el-option v-for="i of YEARS" :key="i.ID" :value="i.ID" :label="i.Name" />
          </el-select>
        </el-form-item>
        <el-form-item label="参赛组别：" class="me-3" >
          <!--          <el-input v-model="params.level" style="width: 100px"/>-->
          <el-select v-model="params.level" style="width: 100px" clearable>
            <el-option v-for="i of LEVELS" :key="i.ID" :value="i.ID" :label="i.Name" />
          </el-select>
        </el-form-item>
        <el-form-item label="选题类型："  class="me-3">
          <!--          <el-input v-model="params.name" style="width: 100px" clearable/>-->
          <el-select v-model="params.topic_id" style="width: 150px" clearable >
            <el-option v-for="i of topics" :key="i.ID" :value="i.ID" :label="i.Name" />
          </el-select>
        </el-form-item>
        <!--        <el-form-item label="晋升结果：" class="me-3" >-->
        <!--          <el-select v-model="params.status" style="width: 150px" clearable filterable>-->
        <!--            <el-option v-for="i of WORKSTATUS" :key="i.ID" :value="i.ID" :label="i.Name" />-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->

        <el-button type="primary"  @click="getList(true)">搜索</el-button>
        <el-button type=""  @click="reset">重置</el-button>
      </div>

      <el-table scrollbar-always-on border
                :span-method="objectSpanMethod"
                :data="list" style="width: calc(100% - 30px);height:calc(100% - 60px);position: absolute;left: 15px;top:50px;padding-bottom: 30px"  v-loading="loading">
        <el-table-column label="年份" min-width="80px"  show-overflow-tooltip
        >
          <template #default="scope">
            {{scope.row.Year|| '-'}}
          </template>
        </el-table-column>
        <el-table-column label="阶段"  min-width="100px"  show-overflow-tooltip>
          <template #default="scope">
            {{stage==1?"初赛":"复赛"}}
          </template>
        </el-table-column>

        <el-table-column label="评分组名" min-width="200px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.GroupName || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="总分"  min-width="100px"  show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.ScoreTotal}}
          </template>
        </el-table-column>
        <el-table-column label="评分详情"  min-width="240px"  show-overflow-tooltip>
          <el-table-column label="分数"  min-width="120px" show-overflow-tooltip>
            <template #default="scope">
<!--              <div>{{scope.row.ScroeID?scope.row.ScroeScore :"未评分"}}</div>-->
              <div v-if="scope.row.ScroeID && scope.row.ScroeLevel === 'A-优先推荐' " style="color: #0d6efd">{{scope.row.ScroeScore }}</div>
              <div v-else-if="scope.row.ScroeID && scope.row.ScroeLevel === 'B-可推荐' " style="color: #fdd50d">{{scope.row.ScroeScore }}</div>
              <div v-else-if="scope.row.ScroeID && scope.row.ScroeLevel === 'C-不推荐'" style="color: #f60606">{{scope.row.ScroeScore }}</div>
              <div v-else>{{scope.row.ScroeID?scope.row.ScroeLevel :"未评分"}}</div>
            </template>
          </el-table-column>
          <el-table-column label="推荐等级"  min-width="120px" show-overflow-tooltip>
            <template #default="scope">
              <div v-if="scope.row.ScroeID && scope.row.ScroeLevel === 'A-优先推荐' " style="color: #0d6efd">{{scope.row.ScroeLevel }}</div>
              <div v-else-if="scope.row.ScroeID && scope.row.ScroeLevel === 'B-可推荐' " style="color: #fdd50d">{{scope.row.ScroeLevel }}</div>
              <div v-else-if="scope.row.ScroeID && scope.row.ScroeLevel === 'C-不推荐'" style="color: #f60606">{{scope.row.ScroeLevel }}</div>
              <div v-else>{{scope.row.ScroeID?scope.row.ScroeLevel :"未评分"}}</div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="参赛组别" min-width="100px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.LevelName || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="作品名称" min-width="300px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.Name || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="选题类型"  min-width="150px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.TopicName || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="参赛队名"   min-width="200px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.TeamName || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="联系人姓名" min-width="100px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.TeamContact || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="联系人手机号" min-width="120px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.TeamPhone || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="提交时间" min-width="170px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.CreatedTime || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="170px" fixed="right">
          <template #default="scope">
            <text style="color: red" v-if="scope.row.Status===3">初赛淘汰</text>
            <text style="color: #ff8800" v-else-if="scope.row.Status===4">初赛二等奖</text>
            <text style="color: #409eff" v-else-if="scope.row.Status===2">初赛一等奖 (进入复赛)</text>
            <text v-else>未设置状态</text>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200px" fixed="right">
          <template #default="scope">
            <el-button  size="small"  class="me-2"  type="primary" @click="seeDetail(scope.$index, scope.row)">详情</el-button>
            <el-dropdown>
              <el-button type="primary" size="small" v-loading="scope.row.loading">
                状态<el-icon class="el-icon--right"><arrow-down /></el-icon>
              </el-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="changeStatue(scope.$index,scope.row,i.ID)" v-for="i of PREWORKSTATUS" :key="i.ID">{{i.Name}}</el-dropdown-item>
                  <!--                  <el-dropdown-item>Action 1</el-dropdown-item>-->
                  <!--                  <el-dropdown-item>Action 2</el-dropdown-item>-->
                  <!--                  <el-dropdown-item>Action 3</el-dropdown-item>-->
                  <!--                  <el-dropdown-item>Action 4</el-dropdown-item>-->
                  <!--                  <el-dropdown-item>Action 5</el-dropdown-item>-->
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pub-footer d-flex align-items-center justify-content-center">
      <el-pagination  v-show="total>0" background
                      layout="total, sizes, prev, pager, next"
                      :page-sizes="[10, 20, 30, 40]"
                      :total="total"
                      v-model:current-page="params.current"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"/>
    </div>

  </div>
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import {ElMessage, ElMessageBox} from "element-plus";
import {formatTime} from "@/utils/dateFun";


import {getName, LEVELS,PREWORKSTATUS} from "@/utils/commonSetting";
import {getYears} from "@/utils/commonSetting"
import {getProvinces, getSchoolList} from "@/api/school";
import {getTopics} from "@/api/topicAdmin";
import {downLoadWithoutBaseUrl, downLoadWithToken} from "@/utils/downloadFiles";
import { useRouter } from "vue-router";
import {exportScoreResults, getScoreResults, updateWorkStage, uploadScoreResults} from "@/api/ScoreResultAdmin";
import {getToken} from "@/utils/token";
import {removeTeacher} from "@/api/student";
let router = useRouter();
const YEARS = getYears()
const provinces = ref([]) // 省份列表
const schools = ref([]) // 学校列表
const topics = ref([])
const stage = 1 // 1-初赛，2-复赛
const params = reactive({
  pageSize:10,
  current:1,
  level:null, // 组别
  topic_id:null, // 选题id
  year:new Date().getFullYear(), // 年份
  status:null, // 晋升状态
})
const total = ref(0)
const list = ref([])
const loading = ref(false)
const exportLoading = ref(false)
const importLoading = ref(false)
const fileList = ref([])
const uploadData = ref({key:"",Authorization:`Bearer ${getToken()}`})
const VUE_APP_uploadurl = process.env.VUE_APP_uploadResultUrl
// const VUE_APP_uploadurl = "/dev/admin/uploadScoreResults"
onMounted(()=>{
  getProvincesAll() // 获取所有的省份列表
  getSchoolAll() // 获取所有的省份列表
  getTopicList()// 获取选题类型
  getList()
})
const objectSpanMethod = ({
                            row,
                            column,
                            rowIndex,
                            columnIndex,
                          }) => {
  if(columnIndex !== 4 && columnIndex !== 5){
    if(row.sumIndex===0){ // 如果是第一个，则合并
      return {
        rowspan: row.ScoresLength,
        colspan: 1,
      }
    }else{
      return { rowspan: 0, colspan: 0 }; // 否则隐藏其他的
    }

  }

}

// 获取选题
const getTopicList = async ()=>{
  const res = await getTopics()
  if(res.success){
    topics.value = res.data || []
  }

}
const reset = ()=>{
  params.current = 1
  params.level = ""
  params.topic_id = ""
  params.year = ""
  params.status = ""
  getList(true)
}
// 获取省份列表
const getProvincesAll = async ()=>{
  const res = await getProvinces()
  if(res.success){
    provinces.value = res.data || []
  }
}
// 获取所有学校
const getSchoolAll = async ()=>{
  const res = await getSchoolList({pageSize:10000,current:1})
  if(res.success){
    schools.value = res.data || []
  }
}
// 获取列表
const getList = async (init)=>{
  if(init){
    params.current = 1
  }
  loading.value = true
  const res = await getScoreResults({...params,stage:stage})
  loading.value = false
  if(res.err_code===0){
    total.value = res.total
    let data = res.data || []
    const listAll = [] // 散开的table
    data.forEach(item=>{
      if(item.Level){
        item.LevelName = getName(LEVELS,item.Level)
      }
      if(item.Topic){
        item.TopicName = item.Topic.Name
      }
      if(item.Team){
        item.TeamName = item.Team.Name
        item.TeamContact = item.Team.Contact
        item.TeamPhone = item.Team.Phone
        item.TeamName = item.Team.Name
        if(item.Team.University){
          item.SchoolName = item.Team.University.Name
        }
      }
      //  创建时间
      if(item.CreatedAt){
        item.CreatedTime = formatTime(item.CreatedAt)
      }
      if(item.Scores && item.Scores.length>0){
        item.ScoresLength = item.Scores.length
        item.Scores.forEach((s,index)=>{
          listAll.push({
            ...item,
            ScroeLevel:s.Level,
            ScroeDetail:s.Detail,
            ScroeAdminUserId:s.AdminUserId,
            ScroeScore:s.Score,
            ScroeStage:s.Stage,
            ScroeID:s.ID,
            sumIndex:index})
        })
      }else{
        item.ScoresLength = 1
        listAll.push({...item,sumIndex:0})
      }
    })
    // list.value = data
    list.value = listAll
  }else{
    return  ElMessage.warning("获取列表失败")
  }
}
// 修改状态
const changeStatue = async (index,item,Status)=>{
  if(!item || !list.value || list.value.length<0){
    return
  }
  list.value[index].loading = true
  const res = await updateWorkStage({ID:item.ID,Status:Status })
  list.value[index].loading = false
  if(res.err_code ===0){
    ElMessage.success("修改成功")
    list.value[index].Status = Status
  }else{
    ElMessage.warning("修改状态失败")
  }

}
// 页码改变
const handleSizeChange = (event) => {
  if(params.pageSize !==event){
    params.current = 1
    params.pageSize = event
    getList()
  }
}
const handleCurrentChange = ()=>{
  getList()
}
// 详情
const seeDetail = (index,item)=>{
  const r = router.resolve({path:'/admin/entrydetail',query:{id:item.ID}})
  window.open(r.href,"_blank")
}
// 导出
const handleExport =async ()=>{
  exportLoading.value = true
  const res = await exportScoreResults({year:params.year?params.year:new Date().getFullYear(),level:params.level,topic_id:params.topic_id,status:params.status,stage:stage})
  exportLoading.value = false
  if(res.err_code===0 && res.data){
    const filesName = `初赛评分结果.xlsx`
    downLoadWithoutBaseUrl(res.data,filesName)
  }else{
    ElMessage.warning(res.err_msg ||"无法下载")
  }
}
const handleUploadExceed = ()=>{
  importLoading.value = true
  ElMessage.warning("等待上传中")
}
// 失败
const handleUploadError = (res)=>{
  fileList.value = []
  importLoading.value = false
  ElMessage.error("上传失败")
}
// 成功
const handleUploadSuccess =async (res)=>{
  importLoading.value = false
  fileList.value = []
  try {
    if(res && res.err_code===0){
      const data = res.data || {}
      const invalidRows = data.invalidRows || 0
      const total = data.total || 0
      const updated = data.updated || 0
      getList(true)
      ElMessageBox.confirm(`上传${total}条，更新${updated}条，无效${invalidRows}条`, '上传成功', {
        type: 'success',
        showConfirmButton:false,
        cancelButtonText: '关闭',

        // center: true,
      }).then(()=>{

      }).catch(()=>{

      })
    }else{
      return ElMessage.error("上传失败")
    }
  }catch (err){
    ElMessage.error("上传失败")
  }

}
// 詳情
const fullScreem = (url)=>{
  if(!url){
    return ElMessage.warning("未获取到文件信息")
  }
  const r = router.resolve({path:'/pdfjs-4.10.38-dist/web/viewer.html',query:{file:url}})
  window.open(r.href,"_blank")
}
</script>

<style scoped lang="scss">
.search--box{
  width: 100%;
  height: 60px;
  overflow-x: scroll;
  display: flex;

}
.search--box{
  ::v-deep .el-form-item__label{
    padding: 0 !important;
  }
}
//::v-deep .search--box .el-form-item__label{
//  padding: 0 5px 0 0 !important;
//}
///deep/  .search--box .el-form-item__label{
//  padding: 0 5px 0 0 !important;
//}
.link{
  background: transparent;
  border-color: transparent;
  color: #3f9dfd;
  height: auto;
  padding: 2px;
}
.link:hover{
  color: rgba(63,157,253,0.7);
}

</style>
